module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Uznach-40ffec04925cd4081dcacbde9ad29732.svg";